import { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGlobalState from "../../Context";
import {
  setIsLoggedIn,
  setLogoutUserId,
  setSignIn,
  setUserDetails,
} from "../../reducer/action";
import jwt_decode from "jwt-decode";
import { checkIfJwt } from "../../utils/jsUtils";

const OAuthRedirect = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const [, dispatch] = useGlobalState();

  const parseUserDetails = (tokenInfo) => {
    return {
      userParam: {
        userId: tokenInfo?.userId,
        email: tokenInfo?.email,
        failedAttempts: tokenInfo?.failedAttempts,
        firstName: tokenInfo?.firstName,
        gstin: tokenInfo?.gstin,
        isEnabled: tokenInfo?.isEnabled,
        isLocked: tokenInfo?.isLocked,
        lastName: tokenInfo?.lastName,
        mobile: tokenInfo?.mobile,
        vendorCode: tokenInfo?.vendorCode,
        vendorName: tokenInfo?.vendorName,
      },
      roleParams: {
        dasRoleParams: tokenInfo?.roleParams,
      },
      sessionId: tokenInfo?.sessionId,
    };
  };

  const initialLoad = useCallback(async () => {
    const oAuthToken = searchParams.get("token");
    const error = searchParams?.get("error");
    const firstTimeLogin = searchParams?.get("firstTimeLogin");
    const userId = searchParams?.get("userId");
    let parsedError = null;
    if (error) {
      parsedError = JSON.parse(error);
    }

    if (checkIfJwt(oAuthToken)) {
      const decodedJwt = jwt_decode(oAuthToken);

      const isTokenExpired =
        oAuthToken && decodedJwt ? decodedJwt.exp * 1000 < Date.now() : false;

      const parsedUserDetails = parseUserDetails(decodedJwt);
      const parsedIdToken = decodedJwt?.idToken;
      if ((error === null || error === undefined) && !isTokenExpired) {
        await dispatch(
          setSignIn({
            token: oAuthToken,
            id_token: parsedIdToken,
            tokenExpiryTime: decodedJwt.exp,
          })
        );
        await dispatch(setIsLoggedIn(true));
        if (parsedUserDetails) {
          await dispatch(setUserDetails(parsedUserDetails));
        }

        navigate("/");
      }
    } else if (firstTimeLogin === "true") {
      navigate("/reset-password", { state: { userId } });
    } else if (
      !!parsedError &&
      !!parsedError?.message &&
      parsedError?.message?.includes("User already logged in")
    ) {
      const messageArr = parsedError?.message?.split(":");

      dispatch(setLogoutUserId(messageArr[1]));
      navigate("/unauthorized");
    } else {
      navigate("/");
    }
  }, [dispatch, navigate, searchParams]);

  useEffect(() => {
    initialLoad();
  }, [initialLoad, searchParams]);

  return <></>;
};
export default OAuthRedirect;
